import React from 'react';
import './index.scss';

export default function TableProgress({
  children,
  percent,
}: {
  children: any;
  percent: number;
}) {
  return (
    <div className="dbo-table-progress">
      <div className="dbo-table-progress-bar" style={{ width: percent * 100 + '%' }}></div>
      {children}
    </div>
  );
}
